const form = document.getElementById('gift-guide-filter-form');
const filterOption = document.querySelectorAll('.gift-guide-filter-options-option');

for (const option of filterOption) {
  option.addEventListener('click', function () {
    const input = this.querySelector('input');
    input.checked = !input.checked;
    form.submit();
  });
}

document.addEventListener('theme:range:update', function () {
  form.submit();
});

const closeIcon = document.querySelector('.gift-guide-filter-close');
const filter = document.querySelector('.gift-guide-filter');
const openButton = document.querySelector('.gift-guide-filter-open button');
const openButtonDiv = document.querySelector('.gift-guide-filter-open');

closeIcon?.addEventListener('click', function () {
  filter?.classList.remove('active');
  openButtonDiv?.classList.add('active');
});

openButton?.addEventListener('click', function () {
  filter?.classList.add('active');
  openButtonDiv?.classList.remove('active');
});
